/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_CatInputs */

const en_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

const ar_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#استخراج`)
};

const bn_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

const de_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

const es_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

const fr_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

const pt_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

const zh_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

const tr_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

const ru_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

const pl_svc_web_scraping_cat = /** @type {(inputs: Svc_Web_Scraping_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCRAPE`)
};

/**
* | output |
* | --- |
* | "#SCRAPE" |
*
* @param {Svc_Web_Scraping_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_cat = /** @type {((inputs?: Svc_Web_Scraping_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_cat(inputs)
	if (locale === "bn") return bn_svc_web_scraping_cat(inputs)
	if (locale === "de") return de_svc_web_scraping_cat(inputs)
	if (locale === "es") return es_svc_web_scraping_cat(inputs)
	if (locale === "fr") return fr_svc_web_scraping_cat(inputs)
	if (locale === "pt") return pt_svc_web_scraping_cat(inputs)
	if (locale === "zh") return zh_svc_web_scraping_cat(inputs)
	if (locale === "tr") return tr_svc_web_scraping_cat(inputs)
	if (locale === "ru") return ru_svc_web_scraping_cat(inputs)
	if (locale === "pl") return pl_svc_web_scraping_cat(inputs)
	return en_svc_web_scraping_cat(inputs)
});
export { svc_web_scraping_cat as "svc_web-scraping_cat" }